import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { ExclamationCircleOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = () => {
  const [results, setResults] = useState([]);

  const [form] = Form.useForm();
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    try {
      const res = await axios.post(`${URL}/stripe/get_stat.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        data.forEach((item, index) => {
          item.key = index
        });
        setResults(data);
      }else {
        alert(res.data.Message);
      }
    }catch(error) {
      console.log(error);

    }
  }

  const columns = [
    {
      title: 'Date',
      dataIndex: 'Day',
      key: 'Day',
    },
    {
      title: 'CraftersPro Trials Started',
      dataIndex: 'CPTrialsStarted',
      key: 'CPTrialsStarted',
    },
    {
      title: 'CraftersPro Subscription Renewals (Yearly)',
      dataIndex: 'CPRenewalsY',
      key: 'CPRenewalsY',
    },
    {
      title: 'CraftersPro Subscription Renewals (Monthly)',
      dataIndex: 'CPRenewalsM',
      key: 'CPRenewalsM',
    },
    {
      title: 'CraftersPro Lifetime Purchases',
      dataIndex: 'CPLifetime',
      key: 'CPLifetime',
    },
    {
      title: 'Payments Failed (Yearly)',
      dataIndex: 'CPRenewalsFailedY',
      key: 'CPRenewalsFailedY',
    },
    {
      title: 'Payments Failed (Monthly)',
      dataIndex: 'CPRenewalsFailedM',
      key: 'CPRenewalsFailedM',
    },
    {
      title: 'Active CraftersPro Subscribers (Yearly)',
      dataIndex: 'ActiveCPSubscribersYearly',
      key: 'ActiveCPSubscribersYearly',
    },
    {
      title: 'Active CraftersPro Subscribers (Monthly)',
      dataIndex: 'ActiveCPSubscribersMonthly',
      key: 'ActiveCPSubscribersMonthly',
    },
    {
      title: 'CraftersPro Sales',
      dataIndex: 'CPSales',
      key: 'CPSales',
    },
    {
      title: 'CraftersFonts Sales',
      dataIndex: 'CFSales',
      key: 'CFSales',
    },
  ]

  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }} 
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
}



export default ExampleCard;
